import { format, parse } from 'date-fns';

export const formatLineChartSimpleDate = (input: string) => {
  const parsedDate = parse(input, 'yyyy-MM', new Date());
  return format(parsedDate, 'MMM yy');
};
